import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@/stores/hooks';
import { fetchClientById } from '@/stores/activeClientSlice';
import { setOrganizationId } from '@/stores/generalFilterSlice';
import { setAllowReEngage, updateMenu } from '@/stores/sideMenuSlice';
import { saveLastClientId } from '@/utils/lastClient';
import encryptDecrypt from '@/utils/encryptDecrypt';

export const useSyncClientFromUrl = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { clientId: encryptedId } = useParams<{ clientId: string }>();
  const clientId = encryptedId ? encryptDecrypt.decryptClientId(encryptedId) : null;
  const activeClientId = useAppSelector((s) => s.activeClient.id);

  // eagerly save to lastClient whenever activeClient changes
  useEffect(() => {
    if (activeClientId) {
      saveLastClientId(activeClientId);
    }
  }, [activeClientId]);

  useEffect(() => {
    if (!encryptedId) {
      dispatch(updateMenu(null));
      return;
    }

    // Encrypted segment present but failed to decrypt ,invalid URL
    if (!clientId) {
      navigate('/clients', { replace: true });
      return;
    }

    dispatch(setOrganizationId(clientId));

    if (clientId === activeClientId) {
      dispatch(updateMenu(encryptedId));
      return;
    }

    dispatch(fetchClientById(clientId)).then((result) => {
      dispatch(updateMenu(encryptedId));
      const reEngage = result.payload?.reEngage === true;
      dispatch(setAllowReEngage(reEngage));
    });
  }, [clientId, encryptedId]);
};